import { Component, OnInit } from '@angular/core';
import { CompanyDocumentsService } from '../../dashboards/files-clients/service/company-documents.service';
import { Observable } from 'rxjs';
import { DocumentTypeDTO } from '../../dashboards/files-clients/interface/company-document.interface';
import { MatDialog } from '@angular/material/dialog';
import { CreateOrUpdateDocumentTypeModalComponent } from '../components/create-or-update-document-type-modal/create-or-update-document-type-modal.component';
import { DocumentTypeService } from '../services/document-type.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-document-type-index',
  templateUrl: './document-type-index.component.html',
  styleUrls: ['./document-type-index.component.scss']
})
export class DocumentTypeIndexComponent implements OnInit{

  constructor(private companyDocumentsService: CompanyDocumentsService,
    private documentTypesService: DocumentTypeService,
    private dialog: MatDialog,
  ){
    this.documentTypes$ = new Observable; 
  }

  public documentTypes$: Observable<DocumentTypeDTO[]>;

  ngOnInit(): void {
    this.getDocumentTypes();
  }

  getDocumentTypes() {
    this.documentTypes$ = this.companyDocumentsService.getDocumentTypes();
  }

  createNewDocumentType(){
    this.openCreateOrUpdateDocumentModal(null);
  }

  updateDocumentType(documentToUpdate: DocumentTypeDTO) 
  {
    this.documentTypesService.getDocumentTypeById(documentToUpdate.documentTypeId)
    .subscribe({
      next:(doc) => {
        this.openCreateOrUpdateDocumentModal(doc);
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage || 'Ha ocurrido un error',
          icon: 'error'
        });
      }
    })
  }

  private openCreateOrUpdateDocumentModal(document: DocumentTypeDTO | null) {
    const dialogRef = this.dialog.open(CreateOrUpdateDocumentTypeModalComponent, {
      disableClose: false,
      width: '90vw',
      height: '80vh',
      data: document
    })
    dialogRef.afterClosed()
    .subscribe({
      next:(sucess: boolean) => {
        if(sucess){
          this.getDocumentTypes();
        }
      }
    })
  }
}
